import { merchantApi } from '@/config/axios'

export interface O2oProviderMerchantPageReqVO {
  pageNo: number
  pageSize: number
  realName?: string
  mobile?: string
  status?: string
}

export interface O2oProviderMerchantRespVO {
  id: number
  userId?: number
  storeId?: number
  realName: string
  mobile: string
  avatar?: string
  gender?: number
  status: string
  authLevel?: number
  ratingAvg?: number
  completedOrders?: number
  depositStatus?: string
  createTime?: string
}

export function getO2oMerchantProviderPage(params: O2oProviderMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oProviderMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/provider/page',
    params
  })
}

export function getO2oMerchantProvider(id: number) {
  return merchantApi.get<O2oProviderMerchantRespVO>({
    url: '/merchant-api/o2o/provider/get',
    params: { id }
  })
}

export function updateO2oMerchantProviderStatus(data: { id: number; status: string }) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/provider/update-status',
    data
  })
}
